/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface MembershipProductRequest {

    /**
     * Product ID
     */
    id?: number;

    /**
     * Name of the membership product
     */
    name?: string;

    /**
     * Short summary of the membership product
     */
    summary?: string;

    /**
     * Description of the membership product
     */
    description?: string;

    /**
     * Monthly price in cents
     */
    price?: number;

    /**
     * Monthly price in dollars
     */
    dollar_price?: number;

    /**
     * Period of the membership ('monthly', 'annually')
     */
    period?: string;

    /**
     * Product Sku of the membership
     */
    product_sku?: string;

    /**
     * Legacy Level of membership
     */
    legacy_level?: number;

    /**
     * 'Value' rank for this membership. Determines upgrade/downgrade/crossgrade
     */
    rank?: number;

    /**
     * The confirmation message that should be shown after purchasing this product initially.
     */
    confirmation_message?: string;

    /**
     * Whether this membership product can be switched to.
     */
    offered_for_switching?: boolean;

    /**
     * Whether this product is available for new signups
     */
    offered?: boolean;

    /**
     * Monthly price in cents
     */
    monthly_price?: number;

    /**
     * Annual price in cents
     */
    annual_price?: number;

}

@Model('MembershipProduct')
export class ApiMembershipProduct extends BaseModel implements MembershipProductRequest {

    /**
     * Product ID
     */
    
    
    id: number;

    /**
     * Name of the membership product
     */
    
    
    name: string;

    /**
     * Short summary of the membership product
     */
    
    
    summary: string;

    /**
     * Description of the membership product
     */
    
    
    description: string;

    /**
     * Monthly price in cents
     */
    
    
    price: number;

    /**
     * Monthly price in dollars
     */
    
    
    dollar_price: number;

    /**
     * Period of the membership ('monthly', 'annually')
     */
    
    
    period: string;

    /**
     * Product Sku of the membership
     */
    
    
    product_sku: string;

    /**
     * Legacy Level of membership
     */
    
    
    legacy_level: number;

    /**
     * 'Value' rank for this membership. Determines upgrade/downgrade/crossgrade
     */
    
    
    rank: number;

    /**
     * The confirmation message that should be shown after purchasing this product initially.
     */
    
    
    confirmation_message: string;

    /**
     * Whether this membership product can be switched to.
     */
    
    
    offered_for_switching: boolean;

    /**
     * Whether this product is available for new signups
     */
    
    
    offered: boolean;

    /**
     * Monthly price in cents
     */
    
    
    monthly_price: number;

    /**
     * Annual price in cents
     */
    
    
    annual_price: number;

}
